<tg-row>
    <tg-col md="9" sm="12">
        <tg-row>
            <tg-col md="6" sm="12" *ngIf="!isSummaryStep">
                <button tgButton2 tgStyle="primary" (click)="onContinueTo()" class="motors-footer__margin-right" [disabled]="photosUploading$ | async">
                    Continue to {{ continueToTitle$ | async }}
                </button>

                <tm-start-over-button *ngIf="!isEditOrRelistPage" [disabled]="
                    (listingActionLoading$ | async) ||
                    (listingActionResponse$ | async)?.success">
                </tm-start-over-button>
            </tg-col>

            <tg-col md="6" sm="12" *ngIf="isSummaryStep && isEditOrRelistPage"
                class="motors-footer__summary-save-change">
                <button tgButton2 [tgStyle]="shouldTopUp ? 'primary' : 'secondary'" (click)="onShowTopUpModal(true)"
                    class="motors-footer__summary-topup--button"
                    [disabled]="(listingActionLoading$ | async) || (listingActionResponse$ | async)?.success">
                    Top up my account
                </button>

                <button *ngIf="isRelistPage" tgButton2 [tgStyle]="shouldTopUp ? 'secondary' : 'primary'"
                    class="motors-footer__summary-create-listing--button" (click)="onEditOrRelistListing()" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success" [tgLoading]="listingActionLoading$ | async">
                    Start my listing
                </button>

                <button *ngIf="isEditPage" (click)="onEditOrRelistListing()" tgButton2 [tgStyle]="shouldTopUp ? 'secondary' : 'primary'"
                    class="motors-footer__summary-topup--button" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success" [tgLoading]="listingActionLoading$ | async">
                    Update my listing
                </button>
            </tg-col>

            <tg-col md="6" sm="12" *ngIf="isSummaryStep && !isEditOrRelistPage" class="motors-footer__summary-topup">
                <button tgButton2 [tgStyle]="shouldTopUp ? 'primary' : 'secondary'" (click)="onShowTopUpModal(true)"
                    class="motors-footer__summary-topup--button" [disabled]="
                  (listingActionLoading$ | async) ||
                  (listingActionResponse$ | async)?.success">
                    Top up my account
                </button>

                <button tgButton2 [tgStyle]="shouldTopUp ? 'secondary' : 'primary'" class="motors-footer__summary-create-listing--button"
                    (click)="onCreateListing()" [disabled]="!createOrEditOrRelistListingEnabled"
                    [tgLoading]="listingActionLoading$ | async">
                    Start my listing
                </button>
            </tg-col>

            <tg-col *ngIf="!isEditOrRelistPage" md="4" sm="12"
                [ngClass]="{'motors-footer__save-and-exit--centre': isCompact}">
                <button tgButton2 linkStyle class="motors-footer__save-and-exit" (click)="onSaveAndExit()" [disabled]="photosUploading$ | async">
                    Save and exit
                </button>
            </tg-col>
        </tg-row>
    </tg-col>
</tg-row>

<tg-modal *ngIf="isCreditAccountModalVisible" (close)="onShowTopUpModal(false)"
    class="motors-page-footer__credit-account-modal" fullscreen>
    <tmm-credit-account (cancelled)="onShowTopUpModal(false)" (creditAdded)="onCreditAdded()"
        (topupFailed)="onCreditFailure()">
    </tmm-credit-account>
</tg-modal>
